export default __webpack_public_path__ + "static/media/rotate.b6447eac.svg";